import { styled, Typography } from '@mui/material';

export const MyDataWrapper = styled('div')({
  margin : '57px auto',
});

export const MyDataHeader = styled('div')({
  display        : 'flex',
  justifyContent : 'space-between',
  alignItems     : 'center',
  marginBottom   : '13px',
});

export const Title = styled(Typography)({
  fontFamily    : 'Montserrat',
  fontWeight    : '700',
  textTransform : 'uppercase',
});

export const MyDataContent = styled('div')(({ theme, isEmpty }) => ({
  margin     : '24px auto',
  background : isEmpty ? theme.palette.primary.white : 'transparent',
  padding    : `${isEmpty ? 36 : 0}px 0px`,
  overflowX  : 'hidden',
}));

export const MyDataList = styled('div')({
  display    : 'flex',
  alignItems : 'stretch',
  gap        : '16px',
});
